import { Routes } from '@angular/router';
import { NoResultsComponent } from '@woolworthsnz/search';
import { EDR_BOOST_OFFERS_PATH, SEARCH_LIST_ITEMS_PATH, SEARCH_PRODUCTS_PATH } from '@woolworthsnz/shop';
import { FeatureRedirectGuard, SearchTarget } from '@woolworthsnz/styleguide';
import { ShoppingListComponent } from '../shopping-list/components';
import { BrowseDepartmentsPage } from './pages/browse-departments/browse-departments.page';
import { BrowseSection, SearchPage } from './pages/search/search.page';
import { SearchResultsResolver } from './search-results.resolver';
import { SearchListItemsParamGuard } from './search-list-items-param.guard';
import { ShopperGuard } from '../authentication/guards';
import { ContextResponse } from '@woolworthsnz/trader-api';

// For some reason Compodoc complains when you have the routes typed here, so instead it gets casted when used
export const routes: Routes = [
	{
		path: SEARCH_PRODUCTS_PATH,
		children: [
			{
				path: '',
				component: SearchPage,
				resolve: {
					searchResults: SearchResultsResolver,
				},
				data: { target: SearchTarget.Search, gtmListName: 'Search' },
				runGuardsAndResolvers: 'always',
			},
			{
				outlet: 'shopping-list',
				path: '',
				component: ShoppingListComponent,
			},
		],
	},
	{
		path: `${SEARCH_PRODUCTS_PATH}/noresults`,
		children: [
			{
				path: '',
				component: NoResultsComponent,
				runGuardsAndResolvers: 'always',
			},
			{
				outlet: 'shopping-list',
				path: '',
				component: ShoppingListComponent,
			},
		],
	},
	{
		path: 'browse',
		component: SearchPage,
		resolve: {
			searchResults: SearchResultsResolver,
		},
		data: { target: SearchTarget.Browse, gtmListName: 'Browse', browseSection: BrowseSection.Root },
		runGuardsAndResolvers: 'always',
	},
	{
		path: 'browse/departments',
		component: BrowseDepartmentsPage,
	},
	{
		path: 'browse/:department',
		component: SearchPage,
		resolve: {
			searchResults: SearchResultsResolver,
		},
		data: { target: SearchTarget.Browse, gtmListName: 'Browse' },
		runGuardsAndResolvers: 'always',
	},
	{
		path: 'browse/:department/:aisle/:shelf',
		component: SearchPage,
		resolve: {
			searchResults: SearchResultsResolver,
		},
		data: { target: SearchTarget.Browse, gtmListName: 'Browse' },
		runGuardsAndResolvers: 'always',
	},
	{
		path: 'browse/:department/:aisle',
		component: SearchPage,
		resolve: {
			searchResults: SearchResultsResolver,
		},
		data: { target: SearchTarget.Browse, gtmListName: 'Browse' },
		runGuardsAndResolvers: 'always',
	},
	{
		path: 'specials',
		component: SearchPage,
		resolve: {
			searchResults: SearchResultsResolver,
		},
		data: {
			target: SearchTarget.Specials,
			gtmListName: 'Specials',
			browseSection: BrowseSection.SpecialsRoot,
		},
		runGuardsAndResolvers: 'always',
	},
	{
		path: 'specials/:department/:aisle/:shelf',
		component: SearchPage,
		resolve: {
			searchResults: SearchResultsResolver,
		},
		data: { target: SearchTarget.Specials, gtmListName: 'Specials' },
		runGuardsAndResolvers: 'always',
	},
	{
		path: 'specials/:department/:aisle',
		component: SearchPage,
		resolve: {
			searchResults: SearchResultsResolver,
		},
		data: { target: SearchTarget.Specials, gtmListName: 'Specials' },
		runGuardsAndResolvers: 'always',
	},
	{
		path: 'specials/:department',
		component: SearchPage,
		resolve: {
			searchResults: SearchResultsResolver,
		},
		data: { target: SearchTarget.Specials, gtmListName: 'Specials' },
		runGuardsAndResolvers: 'always',
	},
	{
		path: 'products/:dynamicProductGroup',
		component: SearchPage,
		resolve: {
			searchResults: SearchResultsResolver,
		},
		data: { target: SearchTarget.DynamicProductGroup, gtmListName: 'DynamicProductGroup' },
		runGuardsAndResolvers: 'paramsOrQueryParamsChange',
	},
	{
		path: 'productgroup/:groupId',
		component: SearchPage,
		resolve: {
			searchResults: SearchResultsResolver,
		},
		data: { target: SearchTarget.ProductGroup, gtmListName: 'ProductGroup' },
		runGuardsAndResolvers: 'paramsOrQueryParamsChange',
	},
	{
		path: SEARCH_LIST_ITEMS_PATH,
		component: SearchPage,
		resolve: {
			searchResults: SearchResultsResolver,
		},
		canActivate: [SearchListItemsParamGuard],
		data: {
			target: SearchTarget.SKUs,
		},
		runGuardsAndResolvers: 'paramsOrQueryParamsChange',
	},
	{
		path: `everyday-rewards-boosts/:campaignId`,
		component: SearchPage,
		resolve: {
			searchResults: SearchResultsResolver,
		},
		data: {
			target: SearchTarget.BoostOffer,
			gtmListName: 'BoostOffers',
			feature: ContextResponse.EnabledFeaturesEnum.BoostShopRange,
			featureRedirectUrl: EDR_BOOST_OFFERS_PATH,
		},
		canActivate: [ShopperGuard, FeatureRedirectGuard],
		runGuardsAndResolvers: 'paramsOrQueryParamsChange',
	},
];
